import React from "react";

import Modal from "../../../components/dialogs/modal";
import List from "../../../components/layout/list";

import {
  DiscountAmountType,
  ReceiptDiscountItem,
  ReceiptItem
} from "../../../models/User";

import { ReceiptDetailsModalProps } from "./types";
import useStyles from "./styles";
import { Currency } from "../../../components/misc/Currency";

const ReceiptDetailsModal = ({
  visible,
  onOk,
  receipt
}: ReceiptDetailsModalProps) => {
  const styles = useStyles();

  const formatDiscount = (discount: ReceiptDiscountItem) => {
    if (discount.amountType === DiscountAmountType.Percentage) {
      return `-${discount.amount * 100}%`;
    }

    return <Currency value={-discount.amount} />;
  };

  const renderReceiptItem = (receiptItem: ReceiptItem) => (
    <div>
      <div className={styles.receiptItemHeader}>
        <span className={styles.receiptItemName}>
          {receiptItem.productName}
        </span>

        <span className={styles.receiptItemPrice}>
          <Currency
            value={receiptItem.discountedPrice ?? receiptItem.price}
            currency={receipt.currency}
          />
        </span>
      </div>

      <div className={styles.receiptItemQuantityContainer}>
        <span className={styles.receiptItemQuantity}>
          Quantity:
          {` ${receiptItem.quantity}`}
        </span>
        <span className={styles.receiptItemRefundQuantity}>
          Refund quantity:
          {` ${receiptItem.refundQuantity}`}
        </span>
      </div>
    </div>
  );

  return (
    <Modal
      open={visible}
      title={`Details for receipt ${receipt.id}`}
      actions={[
        {
          text: "Ok",
          type: "ok",
          action: onOk
        }
      ]}
    >
      <>
        <List
          items={receipt.items}
          renderItem={renderReceiptItem}
          keyExtractor={receiptItem => receiptItem.id}
        />

        {receipt.discountItem && (
          <div className={styles.discount}>
            Discount applied: {formatDiscount(receipt.discountItem)}
          </div>
        )}

        <div className={styles.receiptTotal}>
          Total amount:{" "}
          <Currency value={receipt.netAmount} currency={receipt.currency} />
        </div>
      </>
    </Modal>
  );
};

export default ReceiptDetailsModal;
